import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {MatIcon} from '@angular/material/icon';
import {DateTimeIsoString} from '@aviary/store/common/common.types';
import {NgClass, NgTemplateOutlet} from '@angular/common';
import {isPopulatedString} from '@aviary/store/common/typing.helpers';

type LeftOrRight = 'LEFT' | 'RIGHT';

@Component({
  selector: 'mx-direct-message',
  host: {
    class: 'hk-delegate-vertical-scrolling pe-0'
  },
  templateUrl: './direct-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormatPipe, ReactiveFormsModule, MatIcon, NgClass, NgTemplateOutlet]
})
export class DirectMessageComponent {
  private _messageSide: LeftOrRight;
  private _iconBgClasses: string;
  private _messageIconText: string = '';
  public calculatedBodyClasses: string = '';
  public calculatedDateClasses: string = '';
  public showIconBg: boolean;
  public useTextForIcon: boolean;
  @Input() messageBody: string;
  @Input() messageDate: DateTimeIsoString;
  @Input() messageIconName: string = 'person';
  @Input() iconClasses: string = 'text-on-surface-variant';

  @Input({required: true}) set bodyClasses(bodyClasses: string) {
    this.calculatedBodyClasses += ` ${bodyClasses}`;
  }

  @Input() set dateClasses(dateClasses: string) {
    this.calculatedDateClasses += ` ${dateClasses}`;
  }

  @Input()
  set messageSide(messageSide: LeftOrRight) {
    this._messageSide = messageSide;
    this.calculatedBodyClasses += ` ${messageSide === 'LEFT' ? 'ml-3 rounded-br-[2rem]' : 'mr-3 rounded-bl-[2rem]'}`;
    this.calculatedDateClasses += ` ${messageSide === 'LEFT' ? 'justify-end pr-[min(3.75rem,22%)]' : 'justify-start pl-[min(3.75rem,22%)]'}`;
  }

  get messageSide(): LeftOrRight {
    return this._messageSide
  }

  @Input()
  set iconBgClasses(iconBgClasses: string | undefined) {
    this._iconBgClasses = iconBgClasses ?? 'bg-neutral-200';
    this.showIconBg = isPopulatedString(iconBgClasses);
  }

  get iconBgClasses(): string {
    return this._iconBgClasses
  }

  @Input()
  set messageIconText(messageIconText: string | undefined) {
    this._messageIconText = messageIconText ?? '';
    this.useTextForIcon = isPopulatedString(messageIconText);
  }

  get messageIconText(): string {
    return this._messageIconText
  }
}
